import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'utils/withRouter';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import ActionButtons from 'common/navigation/components/action-buttons';
import styled from 'styled-components';
import { powerBiHomeUrl } from '../../utils/app-configs';

const StyledButton = styled(Button)`
  background-color: ${p => p.theme.colors.themeSecondary};
  color: white;
  border: none;
  text-transform: uppercase;
`;

const StyledIcon = styled(Icon)`
  margin-left: 16px;
  color: white;
`;

const Worklist = ({
  renderMenu,
  getWorklistDefinitions,
  definitions,
  isDefinitionsLoading,
  match,
  history,
  intl,
}) => {
  const powerBiReports = useSelector(state => state.powerBiReports.powerBiReports);

  useEffect(() => {
    getWorklistDefinitions();
  }, []);

  useEffect(() => {
    // TODO: check if this is not an anti-pattern
    // when we receive ids, and no (valid) id is already present in the url,
    // navigate to the first id.
    if (definitions.length && !match.params.worklistId) {
      history.replace(definitions[0].id);
    }
  }, [definitions?.length, match?.params?.worklistId]);

  const powerBiReportsWorklist = powerBiReports?.filter(report =>
    report?.location === 'worklist');

  const actionButtons = powerBiReportsWorklist?.length > 0 && <ActionButtons>
    <StyledButton onClick={() => window.open(powerBiHomeUrl, '_blank')}>
      <FormattedMessage id='powerBi.OPEN' />
      <StyledIcon className='fa-solid fa-arrow-up-right-from-square' />
    </StyledButton>
  </ActionButtons>;

  const getMenuItems = () => {
    if (isDefinitionsLoading) {
      return [{ uri: '', title: intl.formatMessage({ id: 'common.LOADING' }) }];
    }

    return [
      ...definitions?.map(d => ({
        uri: `/worklists/${d.id}`,
        title: d?.description?.toUpperCase(),
        active: match.params.worklistId === d.id,
        absolute: true,
      })),
      ...powerBiReportsWorklist?.map(report => ({
        uri: `/worklists/${report?.id}`,
        title: report?.title?.toUpperCase(),
        active: true,
        absolute: true,
      })),
    ];
  };

  return (
    <>
      {renderMenu(actionButtons, getMenuItems())}
    </>
  );
};

Worklist.propTypes = {
  renderMenu: PropTypes.func.isRequired,
  getWorklistDefinitions: PropTypes.func.isRequired,
  definitions: PropTypes.array,
  isDefinitionsLoading: PropTypes.bool,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(withRouter(Worklist));
